import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=e55c7680&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e55c7680')) {
      api.createRecord('e55c7680', component.options)
    } else {
      api.reload('e55c7680', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=e55c7680&", function () {
      api.rerender('e55c7680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EBsvemq730Ll/JS/offershelp.vue"
export default component.exports